<div *ngIf="!_disabled" [ngClass]="{'ng-invalid ng-dirty': isCurrentlyInvalid}">
	<label>{{ 'form.field.invoiceDate' | translate }}<span *ngIf="required" class="text-danger">*</span></label>
	<p-calendar
		[(ngModel)]="_calendarValue"
		[inputId]="controlName"
		[showIcon]="true"
		dateFormat="dd/mm/yy"
		dataType="string"
		[keepInvalid]="true"
		(onSelect)="onCalendarChange($event)"
		(onClearClick)="onCalendarChange(null)"
		(onInput)="onCalendarInput($event.target.value)"
		(onBlur)="propagateTouched()"
		[styleClass]="isCurrentlyInvalid ? 'ng-invalid ng-dirty w-100' : 'w-100'"
		[inputStyleClass]="isCurrentlyInvalid ? 'ng-invalid is-invalid' : ''"
		[disabled]="_disabled"
		appendTo="body"
	></p-calendar>
	<div *ngIf="isCurrentlyInvalid" class="invalid-feedback text-danger d-block">
		{{ currentErrorMessage }}
	</div>
</div>